import { useEffect, useState } from "react";
import { entGetDependencies } from "../salaryEnterpriseApi";

export default function SalaryDependencyGraph() {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    entGetDependencies()
      .then(setData)
      .catch((e) => setError(e?.detail || e?.message || "Failed to load"));
  }, []);

  if (error) return <div className="bw-alert-error">{error}</div>;
  if (!data) return <p className="text-sm text-slate-600">Loading dependency graph…</p>;

  return (
    <div className="bw-stack">
      <h2 className="bw-section-title">Component dependencies</h2>
      {data.has_cycles ? (
        <div className="bw-alert-error">Circular dependencies detected. Fix formulas before payroll run.</div>
      ) : (
        <p className="text-sm text-emerald-700">No circular references detected.</p>
      )}

      <div className="bw-table-wrap">
        <table className="bw-table">
          <thead>
            <tr>
              <th>From</th>
              <th>Depends on</th>
            </tr>
          </thead>
          <tbody>
            {(data.edges || []).map((e, i) => (
              <tr key={i}>
                <td>{e.from}</td>
                <td>{e.to}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {(data.cycles || []).length > 0 ? (
        <div>
          <h3 className="font-semibold text-red-700">Cycles</h3>
          <pre className="text-xs bg-red-50 p-3 rounded">{JSON.stringify(data.cycles, null, 2)}</pre>
        </div>
      ) : null}
    </div>
  );
}
